import { UlmClientType } from "@custom-types/ulm-types";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/store-helper";

/**
 * Returns the ULM config client ID
 */
export const ulmConfigClientSelector: (state: RootState) => UlmClientType =
  createSelector(
    (state: RootState) => state,
    (state: RootState) => {
      return state.ulmConfig.client;
    }
  );
